import React, { useState } from "react";

export const AsignationTableRow = ({
	el,
	setCourseAsignmentToEdit,
	openModal2,
	deleteAsignment,
	setShowEvaluationResult,
	openModal3,
	askQuiz,
}) => {
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);

	const buttonAction = (el) => {
		setCourseAsignmentToEdit(el);
		openModal2();
	};

	const buttonAction2 = (el) => {
		deleteAsignment(el);
	};
	const buttonAction3 = async (el) => {
		// console.log("hace la consulta");
		setShowEvaluationResult(true);
		await askQuiz(el);
		// openModal3();
	};

	function calcularTiempoEmpledo(start, end) {
		if (!start || !end) return "-";

		// Si es Timestamp de Firestore, convertir a Date
		const fechaInicio = start.toDate ? start.toDate() : new Date(start);
		const fechaFin = end.toDate ? end.toDate() : new Date(end);

		if (isNaN(fechaInicio) || isNaN(fechaFin)) return "-";

		let diffMs = fechaFin - fechaInicio;
		if (diffMs < 0) return "-";

		const horas = Math.floor(diffMs / (1000 * 60 * 60));
		const minutos = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

		return `${horas} ${horas === 1 ? "hora" : "horas"} ${minutos} ${
			minutos === 1 ? "minuto" : "minutos"
		}`;
	}

	// function calcularTiempoEmpledo(startISO, endISO) {
	// 	if (!startISO || !endISO) return "-";

	// 	const fechaInicio = new Date(startISO);
	// 	const fechaFin = new Date(endISO);

	// 	// Verifica que sean fechas válidas
	// 	if (isNaN(fechaInicio) || isNaN(fechaFin)) return "--";

	// 	let diffMs = fechaFin - fechaInicio; // diferencia en milisegundos
	// 	if (diffMs < 0) return "---";

	// 	const horas = Math.floor(diffMs / (1000 * 60 * 60));
	// 	const minutos = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

	// 	return `${horas} ${horas === 1 ? "hora" : "horas"} ${minutos} ${
	// 		minutos === 1 ? "minuto" : "minutos"
	// 	}`;
	// }

	const totalTime = calcularTiempoEmpledo(el.dateStartCourse, el.dateEndCourse);
	const date1 = new Date(el.initialDate.seconds * 1000).toLocaleDateString();
	const date2 = new Date(el.finalDate.seconds * 1000).toLocaleDateString();

	return (
		<tr className="fila-tabla-cuenstas">
			{/* <td className="colTableDocuments0">{el.area}</td> */}
			<td className="colTableDocuments1">{el.course}</td>
			<td className="colTableDocuments1">
				{el.nameStudent} - {el.student}
			</td>
			{/* <td className="colTableDocuments1">{el.student}</td> */}
			<td className="colTableDocuments1">
				{date1} - {date2}
			</td>
			{/* <td className="colTableDocuments1">{date2}</td> */}
			<td className="colTableDocuments1">{Math.round(el.calification)}</td>
			<td className="colTableDocuments1">{totalTime}</td>
			<td className="colTableDocuments1">{el.intents}</td>
			<td className="colTableDocuments1">{el.califiactionDAte}</td>
			<td className="colTableDocuments1">{el.status}</td>

			<td className="colTableDocuments2">
				<button onClick={() => buttonAction(el)} className="btnEditDocuments">
					Editar
				</button>

				<button
					onClick={() => buttonAction2(el)}
					className="btnDeleteDocuments"
				>
					Borrar
				</button>
				{Boolean(el.calification) && (
					<button
						onClick={() => buttonAction3(el)}
						className="btnViewDocuments"
					>
						Evaluación
					</button>
				)}
			</td>
		</tr>
	);
};
